import { Action } from "redux";
import { createActionCreator } from "deox";
import { ThunkDispatch } from "redux-thunk";

import CONFIG from "@APP/config";
import { AppState } from "@APP/redux";
import { RequestResponse, RTP, SenderDataResponse } from "@APP/types";
import { API, AppLocalStorage } from "@APP/services";

export const setRtpSuccess = createActionCreator(
  "@rtp/SET_RTP_SUCCESS",
  (resolve) =>
    (rtpData: {
      senderData: SenderDataResponse;
      rtpData: RequestResponse;
      rtp: RTP;
      rtpKey: string;
    }) =>
      resolve(rtpData),
);

/**
 * Clears the payment session. Handled by both the `rtp` and the `banks`
 * reducers, so the previously chosen bank is dropped along with the request
 * details - otherwise it leaks into the next payment request (LLOYD-392).
 */
export const clearRtpState = createActionCreator(
  "@rtp/CLEAR_RTP_STATE",
  (resolve) => () => resolve(),
);

/**
 * The requesting organisation's logo, fetched on the landing screen. It is held
 * in the persisted `rtp` slice rather than in local component state so that the
 * page header can show the merchant on every screen of the journey, including
 * after the round trip out to the payer's bank.
 */
export const setOrgLogo = createActionCreator(
  "@rtp/SET_ORG_LOGO",
  (resolve) => (orgLogo: string | null) => resolve(orgLogo),
);

export const getRtpDetails =
  (senderDataPayload: string, rtpDataPayload: string) =>
  async (dispatch: ThunkDispatch<AppState, void, Action>): Promise<AppState["rtp"]> => {
    const senderData = await API.getSenderData(senderDataPayload);
    const rtpDecoded = await API.decodeRTP(rtpDataPayload);
    const rtpData = (await API.getRTP(rtpDecoded.paymentRequestId)).data[0];

    if (senderData && senderData?.companyInfo && senderData?.companyInfo?.id) {
      AppLocalStorage.setItem("orgId", senderData?.companyInfo?.id);
    }

    dispatch(
      setRtpSuccess({
        senderData,
        rtpData: rtpDecoded,
        rtp: rtpData,
        rtpKey: rtpDataPayload,
      }),
    );

    if (["test", "development"].includes(CONFIG.APP_ENV)) {
      console.info("RTP:", { senderData, rtpDecoded, rtpData });
    }

    return {
      senderData,
      rtpData: rtpDecoded,
      rtp: rtpData,
      rtpKey: rtpDataPayload,
      orgLogo: null,
    };
  };
